import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('data', 'countryDetails');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'countries',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['code'],
    },
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/data/countryDetails.js